export const PLAYER_STATE = {
	IDLE:       'idle',
	PLAYING:    'playing',
	PAUSED:     'paused',
	AD_IDLE:    'ad_idle',
	AD_PLAYING: 'ad_playing',
	AD_PAUSED:  'ad_paused',
};

export const HLS_SUPPORT = {
	SUPPORTED_MSE:            'supported-mse', // MSE (Media Source Extensions)
	SUPPORTED_NATIVE:         'supported-native', // Native HLS (iOS)
	SUPPORTED_NATIVE_AND_MSE: 'supported-native-and-mse', // Native HLS (Mac Safari)
	UNSUPPORTED:              'unsupported', // No support
};

export const HLS_DEFAULT_OPTIONS = {
	debug:                false,
	enableWorker:         true,
	lowLatencyMode:       true,
	maxBufferLength:      30,
	maxBufferSize:        0,
	backBufferLength:     120,
	capLevelToPlayerSize: true,
	maxBufferHole:        0,
};
